export default function FAQSection() {
  const faqs = [
    {
      q: '69视频是什么？',
      a: '69视频是一个综合性免费影视在线观看平台，提供西瓜视频免费、91在线视频等影视资源入口。平台汇集了海量电影大全、电视剧全集、综艺节目等高清视频内容，支持免费在线观看，播放流畅不卡顿。',
    },
    {
      q: '69视频是否需要注册？',
      a: '不需要。69视频平台上的所有视频内容均可免费在线观看，无需注册或登录。打开网站即可享受高清影视体验。',
    },
    {
      q: '视频画质如何？是否支持高清？',
      a: '69视频平台上的影视资源支持高清画质播放，大部分内容提供1080P甚至4K画质选项。平台采用先进的视频压缩和CDN加速技术，确保高清播放不卡顿。',
    },
    {
      q: '支持哪些设备观看？',
      a: '69视频完美适配电脑、平板和手机等多种设备。无论你是在家用电脑还是外出用手机，都能获得流畅的观影体验。我们推荐使用Chrome、Safari等主流浏览器访问。',
    },
    {
      q: '视频更新频率如何？',
      a: '69视频每天更新超过1000部影视内容，包括最新上映的电影、热播电视剧、热门综艺节目等。关注我们，不错过任何精彩内容！',
    },
  ];

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema, null, 2) }}
      />
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            关于69视频，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <details
              key={index}
              className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between px-5 py-4 list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 font-heading pr-4">
                  {faq.q}
                </h3>
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-background-200 group-open:bg-primary-100 flex-shrink-0 transition-colors">
                  <i className="ri-add-line text-foreground-600 group-open:hidden text-sm"></i>
                  <i className="ri-subtract-line text-primary-600 hidden group-open:block text-sm"></i>
                </div>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}